
<template>
    <div class="center examplex">
        <vs-row v-if="users[0]">
            <vs-col sm="12" lg="3" class="ml-auto">
                <vs-button
                    class="ml-auto"
                    relief
                    success
                    :loading="loadingExcel"
                    @click="getExcel"
                >
                    Descargar reporte
                </vs-button>
            </vs-col>
        </vs-row>
        <vs-row>
            <vs-col sm="12" lg="3" class="ml-auto">
                <vs-input class="ml-auto" v-model="search" placeholder="Buscar">
                    <template #icon>
                        <i class="fas fa-search"></i>
                    </template>
                </vs-input>
            </vs-col>
        </vs-row>
        <vs-table striped>
            <template #thead>
            <vs-tr>
                <vs-th style="width: 30%;">
                    Alumno
                </vs-th>
                <vs-th style="width: 30%;">
                    Académico
                </vs-th>
                <vs-th style="width: 30%;">
                    Finanzas
                </vs-th>
                <vs-th></vs-th>
            </vs-tr>
            </template>
            <template #tbody>
            <vs-tr
                :key="i"
                v-for="(tr, i) in $vs.getSearch(users, search)"
                :data="tr"
            >
                <vs-td style="vertical-align: top">
                    <vs-row>
                        <vs-col w="2">
                            <vs-avatar circle class="m-auto">
                                <img :src="'/api/personas/' + window.atob(tr.estadoCuenta) + '/avatar'" @error="setAltImg" alt="">
                            </vs-avatar>
                        </vs-col>
                        <vs-col w="10" class="pl-2">
                            <div class="estatus-alumno mb-2" :class="coloresEstatus(tr.estatus_registro_academico)" v-if="tr.estatus_registro_academico">
                                <small><strong>{{tr.estatus_registro_academico}}</strong></small>
                            </div>
                            <p class="mb-1"><strong>{{ tr.nombre }}</strong></p>
                            <p class="mb-0"><small>MATRÍCULA</small></p>
                            <p class="mb-0"><strong>{{ tr.matricula }}</strong></p>
                        </vs-col>
                    </vs-row>
                </vs-td>
                <vs-td style="vertical-align: top">
                    <p class="mb-0 text-uppercase"><small>Ciclo escolar</small></p>
                    <p class="mb-1"><strong>{{ tr.cicloEscolar }}</strong></p>
                    <p class="mb-0 text-uppercase"><small>Programa</small></p>
                    <p class="mb-1"><strong>{{ tr.programa }}</strong></p>
                    <p class="mb-0 text-uppercase"><small>Grupo</small></p>
                    <p class="mb-1"><strong>{{ tr.grupo_administrativo }} ({{ tr.no_lista }})</strong></p>
                    <p class="mb-0 text-uppercase"><small>Grado</small></p>
                    <p class="mb-1"><strong>{{ tr.grado }}</strong></p>
                    <p class="mb-0 text-uppercase"><small>Inscripción académica</small></p>
                    <md-chip class="mini-chip text-uppercase" :class="tr.inscripcion_academica == 'si' ? 'col-green' : 'col-yellow'"><strong> {{ tr.inscripcion_academica }} </strong></md-chip>
                </vs-td>
                <vs-td style="vertical-align: top">
                    <div v-if="!permisos.includes('ocultar-monto-reporte-seguimiento')">
                        <p class="mb-0 text-uppercase"><small>Cartera vencida</small></p>
                        <md-chip class="mini-chip text-uppercase col-red"><strong> {{ tr.cartera_vencida |currency }} </strong></md-chip>
                        <p class="mb-0 text-uppercase"><small>Cargos en tiempo</small></p>
                        <p class="mb-1"><strong>{{ tr.cargos_en_tiempo | currency}}</strong></p>
                        <p class="mb-0 text-uppercase"><small>Monto pagado</small></p>
                            <p class="mb-1"><strong>{{ tr.monto_pagado | currency}}</strong></p> 
                        <p class="mb-0 text-uppercase"><small>Cartera vencida en ciclos anteriores</small></p>
                        <p class="mb-1"><strong>{{ tr.cartera_vencida_ciclos_anteriores | currency}}</strong></p> 
                    </div>
                    <div v-else>
                        <p class="mb-0 text-uppercase"><small>Cartera vencida</small></p>
                        <p class="mb-0"><strong>{{getParce(tr.cartera_vencida) > 0 ? 'CON CARTERA VENCIDA' : 'SIN CARTERA VENCIDA'}}</strong></p>
                        <p class="mb-0 text-uppercase"><small>Cargos en tiempo</small></p>
                        <p class="mb-0"><strong>{{getParce(tr.cargos_en_tiempo) > 0 ? 'CON CARGOS EN TIEMPO' : 'SIN CARGOS EN TIEMPO'}}</strong></p>
                        <p class="mb-0 text-uppercase"><small>Monto pagado</small></p>
                        <p class="mb-0"><strong>{{getParce(tr.monto_pagado) > 0 ? 'CON MONTO PAGADO' : 'SIN MONTO PAGADO'}}</strong></p>
                        <p class="mb-0 text-uppercase"><small>Cartera vencida en ciclos anteriores</small></p>
                        <p class="mb-0"><strong>{{getParce(tr.cartera_vencida_ciclos_anteriores) > 0 ? 'CON CARTERA VENCIDA' : 'SIN CARTERA VENCIDA'}}</strong></p>
                    </div>
                </vs-td>
                <vs-td style="vertical-align: top">
                     <vs-button
                        success
                        flat
                        blank
                        :href="'/estado-de-cuenta/' + window.atob(tr.estadoCuenta)+ '/gestion?institucion_id=' + institucion + '&ciclo_escolar_id=' + cicloEscolar"
                    >
                        Gestión de finanzas
                    </vs-button>
                </vs-td>
            </vs-tr>
            </template>
            <template #notFound>
                Sin información
            </template>
        </vs-table>
    </div>
</template>
<script>
    import alumnos from '../../../../api/requests/alumno'
    export default {
        props: [
            'users',
            'institucion',
            'cicloEscolar',
            'grupo',
            'permisos'
        ],
        data:() => ({
            search: '',
            loadingExcel: false,
            estatusBaja: []
        }),
        created(){
            this.getEstatusAlumno()
        },
        methods:{
            async getEstatusAlumno(){
                try{
                    const params = {
                        type: 'baja'
                    }
                    const {data: response} = await alumnos.getEstatusAlumno(params)
                    response.map(r =>{
                        this.estatusBaja.push(r.status)
                    })
                }catch(error){
                    console.error(error)
                }
            },
            coloresEstatus(estatus){
                if(['Inscrito económico','Reactivación'].includes(estatus)){
                    return 'col-green'
                }else if(['Congelado'].includes(estatus)){
                    return 'col-yellow'
                }else if(this.estatusBaja.includes(estatus)){
                    return 'col-red'
                }else{
                    return 'col-blue'
                }
            },
            getParce(valor){
                const numero = parseInt(valor)
                return numero
            },
            getExcel () {
                this.loadingExcel = true
                let formData = {
                    'institucion_id': this.institucion,
                    'ciclo_escolar_id': this.cicloEscolar,
                    'type_response': 'file'
                }

                if(this.grupo[0] == ''){
                    const eliminarGrupo = this.grupo.shift()
                    formData.grupo_id = this.grupo
                }else{
                    formData.grupo_id = this.grupo
                }

                this.loading = true
                setTimeout(() => {
                    axios.get('/reportes-academicos/getSeguimientoCobranzaAlumnosPorGrupoAcademico', {
                        responseType: 'blob',
                        params: {...formData},
                        // responseType: 'arraybuffer',
                    }).then(response => {
                        this.loadingExcel = false
                        if (response.data instanceof Blob) {
                            const downloadUrl = window.URL.createObjectURL(new Blob([response.data]));
                            const link = document.createElement('a');
                            link.href = downloadUrl;
                            var filename = "";
                            const disposition = response.headers['content-disposition'];
                            if (disposition && disposition.indexOf('attachment') !== -1) {
                                const filenameRegex = /filename[^;=\n]*=((['"]).*?\2|[^;\n]*)/;
                                const matches = filenameRegex.exec(disposition);
                                if (matches != null && matches[1]) {
                                    filename = matches[1].replace(/['"]/g, '');
                                    link.setAttribute('download', filename)
                                }
                            }
                            document.body.appendChild(link);
                            link.click();
                            link.remove();
                        }else{
                            throw { message: 'formatError' }
                        }
                        this.$vs.notification({
                            progress: 'auto',
                            color: 'success',
                            position: 'bottom-right',
                            title: 'Éxito',
                            text: 'Descarga lista'
                        })
                        this.loading = false;
                    }).catch(e => {
                        this.loadingExcel = false
                        this.$vs.notification({
                            progress: 'auto',
                            color: 'danger',
                            position: 'bottom-right',
                            title: 'Ocurrió un problema inesperado'
                        })
                    });
                }, 500);
            },
            setAltImg(event) {
                event.target.src = "https://sigem.maristas.mx/img/default-avatar.jpg"
            },
        },
    }
</script>

<style scoped>
.vs-avatar img{
    object-fit: contain;
}
</style>

<style lang="scss" scoped>
    .estatus-alumno{
        display:inline-block;
        // background-color: #007BFF;
        // color:#ffff;
        padding: 3px 15px;
        border-radius: 7px;
        text-transform: uppercase;
    }
    .col-yellow{
        background: rgb(255, 248, 236);
        color: #febf3d;
    }
    .col-yellow{
        background: rgb(255, 248, 236);
        color: #febf3d;
    }

    .col-red{
        color: #f62d51;
        background: rgb(249, 231, 235);
    }

    .col-green{
        color: #55ce63;
        background: rgb(232, 253, 235);
    }

    .col-purple{
        color: purple;
        background: rgb(232, 218, 239);
    }

    .col-blue{
        color: #2874A6;
        background: rgb(214, 234, 248);
    }

    .col-gray{
        color: #5F6A6A;
        background: rgb(242, 243, 244);
    }

    .col-pink{
        color: #F08080;
        background: rgb(255, 236, 236);
    }

    .col-brown{
        color: #784212;
        background: rgb(250, 229, 211);
    }
    .vs-avatar img{
        object-fit:contain;
    }
</style>

        